// extracted by mini-css-extract-plugin
export default {"small_statistics_container":"SmallStatistics_small_statistics_container__Rg9o1","button_switch":"SmallStatistics_button_switch__pKWz4","active":"SmallStatistics_active__Gpjga"};